import FJUtil from './FJUtil';

const FJVideoUtil = {
    /**
     * @description 返回解码视频帧类型
     * @returns
     */
    getDecodeVideoFrameType: function () {
        if (FJUtil.getBrowser() === 'FF') {
            return 'IMAGEBITMAP';
        }

        if (FJUtil.couldUseWebCodecs('decode') && typeof VideoFrame !== 'undefined') {
            return 'VIDEOFRAME';
        }
        if (
            typeof ImageBitmap !== 'undefined' &&
            typeof createImageBitmap !== 'undefined' &&
            typeof OffscreenCanvas !== 'undefined'
        ) {
            return 'IMAGEBITMAP';
        }
        return 'TYPEDARRAY';
    },
};

export default FJVideoUtil;
